import { Box, BoxProps, Collapsible } from '@chakra-ui/react';
import { MarkdownRenderer } from '@src/components/sco/MarkdownRenderer/index';
import { MarkdownRendererProps } from '@src/components/sco/MarkdownRenderer/index';
import React, { useEffect, useRef, useState } from 'react';
type TruncatedMarkdownRendererProps = {
  shadowStartColor?: BoxProps['bgColor'];
  shadowEndColor?: BoxProps['bgColor'];
  isExpanded?: boolean;
  maxHeightInPx?: number;
} & MarkdownRendererProps;
export const TruncatedMarkdownRenderer = (props: TruncatedMarkdownRendererProps) => {
  const [isExpanded, setIsExpanded] = useState(props.isExpanded || !props.maxHeightInPx || false);
  const [isTruncated, setIsTruncated] = useState(!!props.maxHeightInPx);
  const ref = useRef(null);
  const maxHeight = props.maxHeightInPx;
  const maxShadowHeight = `${props.maxHeightInPx / 4}px`;
  useEffect(() => {
    if (ref.current) {
      if (ref.current.clientHeight <= props.maxHeightInPx) {
        setIsExpanded(true);
        setIsTruncated(false);
      }
    }
  }, [ref.current?.clientHeight]);
  const afterStyles = maxHeight && !isExpanded ? {
    // background: `linear-gradient(180deg, ${props.shadowStartColor || 'rgba(39, 41, 53, 0)'} 0%, ${
    //   props.shadowEndColor || '#272B35'
    // } 100%)`,
    bgImage: `linear-gradient({colors.${props.shadowStartColor}}, {colors.${props.shadowEndColor}})`,
    content: `''`,
    display: 'block',
    height: `${maxShadowHeight}`,
    position: 'relative',
    marginTop: `-${maxShadowHeight}`,
    width: '100%',
    zIndex: 100,
    pointerEvents: 'none' // Allow clicks to pass through this visual layer
  } : {};
  return <Box>
      <Box _after={afterStyles} cursor={isTruncated ? isExpanded ? 'zoom-out' : 'zoom-in' : null} onClick={() => isTruncated && setIsExpanded(!isExpanded)}>
        <Collapsible.Root collapsedHeight={maxHeight ? `${maxHeight}px` : undefined} open={isExpanded}>
          <Collapsible.Content>
            <Box ref={ref} maxHeight={'40vh'} overflow={'auto'}>
              <MarkdownRenderer {...props} />
            </Box>
          </Collapsible.Content>
        </Collapsible.Root>
      </Box>
    </Box>;
};